import { VLActionModal } from "views/uikit/VLModal";
import sadUserIMG from "assets/pngImages/sad-user.png";
import styles from "./style.module.scss";

interface UnavailableModalProps {
  onClose: () => void;
  description?: React.ReactElement;
  actionText: string;
}
export default function UnavailableModal({
  onClose,
  description,
  actionText,
}: UnavailableModalProps) {
  return (
    <VLActionModal
      isOpen={true}
      variant={"general"}
      onClose={onClose}
      onClick={onClose}
      actionLabel={actionText}
    >
      <div className={styles.unavailable}>
        <img src={sadUserIMG} alt="User with no views" />
        <span className={styles.unavailableTitle}>
          This feature is unavailable
        </span>

        {description}
      </div>
    </VLActionModal>
  );
}
